/**
 * Client idempotency keys for money/stock posts (plan/24).
 * Soft-confirm retries must reuse the same key so a flaky response
 * cannot double-post.
 */

/** Prefix + UUID. Call once per user intent; reuse across soft-confirm retries. */
export function newClientIdempotencyKey(prefix: string): string {
  const p = prefix.trim().replace(/-+$/g, "");
  return `${p}-${crypto.randomUUID()}`;
}
